import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { PxCaptchaTypes } from '../types';
import { ErrorCodes, PxError, validateEmailAddress } from '@chegg/one-auth-sdk';
import { getTexts } from '../../lib/contentful/defaultTexts';
import { notificationsRioEvent } from '../../lib/rio/rioEvents';
import { EventTypes, recordEvents } from '../../utils/newRelicEvents';
import { isCredentialsValid } from '../helpers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { emailBlur } from '../sharedActions';
import { initiatePx } from '../../utils/pxUtils';
import { domainSpellingCheck } from '../../utils/passwordValidations';
export var sdkValidateEmailAddressReducers = {
  rejected: function rejected(state, action) {
    var error = action.payload;
    var email = state.signup.credentials.email;
    switch (error.code) {
      case ErrorCodes.invalid_email_structure:
        {
          email.valid = false;
          state.signup.credentials.error = '';
          state.signup.credentials.email.error = getTexts().signup.invalidEmailError;
          return;
        }
      case ErrorCodes.user_already_exists_migrated:
        {
          email.valid = false;
          state.signup.credentials.error = '';
          state.signup.credentials.email.error = getTexts().signup.userExistsInMigrationClientError;
          notificationsRioEvent({
            notifications: {
              type: 'error',
              message_name: 'sign up error',
              message_detail: getTexts().signup.userExistsInMigrationClientError,
              message_id: 'validateEmailAddress: user exists in migration error'
            }
          });
          recordEvents(_defineProperty({}, EventTypes.checkIfEmailTakenFail, {
            clientId: state.clientId,
            error: getTexts().signup.userExistsInMigrationClientError
          }));
          return;
        }
      case ErrorCodes.user_already_exists:
        {
          email.valid = false;
          state.signup.credentials.error = '';
          email.error = getTexts().signup.emailRegisteredError;
          notificationsRioEvent({
            notifications: {
              type: 'error',
              message_name: 'sign up error',
              message_detail: getTexts().signup.emailRegisteredError,
              message_id: 'validateEmailAddress: email already exists error'
            }
          });
          recordEvents(_defineProperty({}, EventTypes.checkIfEmailTakenFail, {
            clientId: state.clientId,
            error: getTexts().signup.emailRegisteredError
          }));
          return;
        }
    }
    if ((error === null || error === void 0 ? void 0 : error.message) !== 'px_error') {
      state.signup.loading = false;
      state.signup.credentials.error = getTexts().signup.genericError;
      notificationsRioEvent({
        notifications: {
          type: 'error',
          message_name: 'sign up error',
          message_detail: getTexts().signup.genericError,
          message_id: 'validate email sdk: genericError'
        }
      });
      recordEvents(_defineProperty({}, EventTypes.checkIfEmailTakenFail, {
        clientId: state.clientId,
        error: getTexts().signup.genericError,
        isCriticalError: error === null || error === void 0 ? void 0 : error.criticalError
      }));
    }
  },
  fulfilled: function fulfilled(state, action) {
    var email = state.signup.credentials.email;
    shouldShowEmailDomainSpellCheck(email);
    email.valid = true;

    // clear validate email address error when signup error is displayed
    if (state.signup.credentials.error !== getTexts().signup.genericError) {
      state.signup.credentials.error = '';
    }

    // validate all credentials to proceed and show the next step
    state.signup.showUserInfo = state.signup.showUserInfo || isCredentialsValid(state.signup);
  }
};
export var sdkValidateEmailAddress = createAsyncThunk('oneauth/sdkValidateEmailAddress', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, dispatch, rejectWithValue, state, env, clientId, authProvider, _state$signup, isSso, email, authType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, dispatch = _ref.dispatch, rejectWithValue = _ref.rejectWithValue;
          state = getState();
          env = state.env, clientId = state.clientId, authProvider = state.sso.authProvider, _state$signup = state.signup, isSso = _state$signup.isSso, email = _state$signup.credentials.email.value;
          _context.prev = 3;
          _context.next = 6;
          return validateEmailAddress(email);
        case 6:
          _context.next = 13;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](3);
          authType = isSso ? authProvider : 'email/password';
          if (_context.t0 instanceof PxError) {
            initiatePx(env, _context.t0, dispatch, clientId, PxCaptchaTypes.SIGNUP, authType, false, function () {
              dispatch(emailBlur());
              dispatch(sdkValidateEmailAddress());
            });
          }
          return _context.abrupt("return", rejectWithValue(_context.t0));
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 8]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
function shouldShowEmailDomainSpellCheck(email) {
  var _domainSpellingCheck;
  var correctedEmailDomain = (_domainSpellingCheck = domainSpellingCheck(email.value)) === null || _domainSpellingCheck === void 0 ? void 0 : _domainSpellingCheck.domain;
  if (correctedEmailDomain) {
    var errText = "".concat(getTexts().signup.emailMisspellError, " ").concat(correctedEmailDomain, "?");
    email.error = errText;
    notificationsRioEvent({
      notifications: {
        type: 'error',
        message_name: 'sign up error',
        message_detail: errText,
        message_id: 'sign up email domain misspell'
      }
    });
  } else {
    email.error = '';
  }
}